import { Vue } from 'vue-property-decorator'
import { IntegrationLatisRepository } from './IntegrationLatisRepository'
import { JtechStore } from 'src/plugins/mobx'

export default class IntegrationLatisController {
  static getInstance () {
    return JtechStore.getSingleton('IntegrationLatisController', new IntegrationLatisController())
  }

  async generateLatis () {
    const forms = await IntegrationLatisRepository.generateLatis()
    const datatable = await IntegrationLatisRepository.latisDispatchList()
    return { forms, datatable }
  }

  async generate (params) {
    return await IntegrationLatisRepository.generate(params)
  }

  async sendLatis (params) {
    return await IntegrationLatisRepository.sendLatis({ id: params.id })
  }
}
